var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightWhite = function SvgChevronRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.162,
    height: 5.121,
    viewBox: "0 0 3.162 5.121"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.162 4.519L1.208 2.56 3.162.6 2.56 0 0 2.56l2.56 2.56z",
    transform: "rotate(-180 1.581 2.56)"
  })));
};
export { SvgChevronRightWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzLjE2MiIgaGVpZ2h0PSI1LjEyMSIgdmlld0JveD0iMCAwIDMuMTYyIDUuMTIxIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0zLjE2MiA0LjUxOUwxLjIwOCAyLjU2IDMuMTYyLjYgMi41NiAwIDAgMi41NmwyLjU2IDIuNTZ6IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDEuNTgxIDIuNTYpIi8+Cjwvc3ZnPgo=";